function initCartTimer() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      const timerWrapper = document.getElementById("cart-timer-wrapper");
      const countdown = document.getElementById("countdown");

      if (!timerWrapper || !countdown) return;

      // Cart empty hai
      if (cart.item_count === 0) {
  timerWrapper.style.display = "none";

  // Timer aur expired flag reset kar do
  localStorage.removeItem("cartEndTime");
  localStorage.removeItem("cartTimerExpired");

  clearInterval(window.cartTimerInterval);
  window.cartTimerInterval = null;

  return;
}
      // Agar timer pehle hi complete ho chuka hai to dubara mat dikhao
if (localStorage.getItem("cartTimerExpired") === "true") {
  timerWrapper.style.display = "none";
  return;
}

      timerWrapper.style.display = "block";

      // Timer pehli baar start karo
      let endTime = localStorage.getItem("cartEndTime");

      if (!endTime) {
        endTime = Date.now() + (10 * 60 * 1000);
        localStorage.setItem("cartEndTime", endTime);
      }

      // Agar interval pehle se chal raha hai to naya mat banao
      if (window.cartTimerInterval) return;

      window.cartTimerInterval = setInterval(() => {

        const endTime = parseInt(localStorage.getItem("cartEndTime"));
        const distance = endTime - Date.now();

        if (distance <= 0) {
  countdown.innerHTML = "00:00";

  // Timer ko hide kar do
  timerWrapper.style.display = "none";

  // Interval band kar do
  clearInterval(window.cartTimerInterval);
  window.cartTimerInterval = null;

  // LocalStorage me flag save kar do ki timer complete ho chuka hai
  localStorage.setItem("cartTimerExpired", "true");

  // End time hata do
  localStorage.removeItem("cartEndTime");

  return;
}

        const totalSeconds = Math.floor(distance / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        countdown.innerHTML =
          String(minutes).padStart(2, "0") +
          ":" +
          String(seconds).padStart(2, "0");

      }, 1000);

    });
}

// Page load pe
document.addEventListener("DOMContentLoaded", initCartTimer);

// Cart drawer ke liye har 1 sec me check
setInterval(initCartTimer, 1000);